import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=6db9b85d&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=6db9b85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db9b85d",
  null
  
)

export default component.exports